import useConfig from 'hooks/useConfig';
import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';

import './survey-preview.less';

function openPopup(url) {
  window.open(
    url,
    '_blank',
    'toolbar=no,scrollbars=yes,resizable=no,top=300,left=500,width=800,height=600',
  );
}

export function useSurveyPreviewPopup() {
  const { config } = useConfig();
  return {
    open: useCallback(async (distributionId) => {
      openPopup(`${config.survey.baseUrl}d/${distributionId}/?isPreview=true`);
    }, [config?.survey.baseUrl]),
  };
}

const SurveyPreview = ({
  distributionId,
  ...rest
}) => {
  const ref = useRef(null);
  const [loaded, setLoaded] = useState();
  const { config } = useConfig();

  useLayoutEffect(() => {
    if (loaded) {
      ref.current.contentWindow.postMessage(rest, '*');
    }
  }, [loaded, ...Object.values(rest)]);

  if (!distributionId || !config?.survey.baseUrl) {
    return null;
  }

  return (
    <iframe
      ref={ref}
      onLoad={() => setLoaded(true)}
      className="survey-preview"
      title="survey-preview"
      src={`${config.survey.baseUrl}d/${distributionId}/?isPreview=true&embedded=true`}
    />
  );
};

export default SurveyPreview;
